import script from "./Template.vue?vue&type=script&setup=true&lang=js"
export * from "./Template.vue?vue&type=script&setup=true&lang=js"

import "./Template.vue?vue&type=style&index=0&id=decb6d72&scoped=true&lang=less"
script.__scopeId = "data-v-decb6d72"

export default script